export enum AvailabilityItemStatus {
    AVAILABLE = 'AVAILABLE',
    AVAILABLE_AND_VERIFIED = 'AVAILABLE_AND_VERIFIED',
    NOT_AVAILABLE_WITH_DATE = 'NOT_AVAILABLE_WITH_DATE',
    AVAILABLE_SOON = 'AVAILABLE_SOON',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
}

export enum AvailabilityItemFrequency {
    ONE_DAY_PER_WEEK = 'ONE_DAY_PER_WEEK',
    TWO_DAYS_PER_WEEK = 'TWO_DAYS_PER_WEEK',
    THREE_DAYS_PER_WEEK = 'THREE_DAYS_PER_WEEK',
    FOUR_DAYS_PER_WEEK = 'FOUR_DAYS_PER_WEEK',
    EVENINGS_AND_WEEKENDS = 'EVENINGS_AND_WEEKENDS',
    FULL_TIME = 'FULL_TIME',
}

export type AvailabilityItem = {
    status: AvailabilityItemStatus;
    frequency: AvailabilityItemFrequency;
    isPartial: boolean;
    confirmed: boolean;
    nextAvailabilityDate?: Date;
};
